import { render, staticRenderFns } from "./DokumentasiProgress.vue?vue&type=template&id=637baaa6"
import script from "./DokumentasiProgress.vue?vue&type=script&lang=js"
export * from "./DokumentasiProgress.vue?vue&type=script&lang=js"
import style0 from "./DokumentasiProgress.vue?vue&type=style&index=0&id=637baaa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports